var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWithdrawals16X16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 16,
    viewBox: "0 0 15.999 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29319",
    "data-name": "Group 29319",
    transform: "translate(-100.815 -29.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48386",
    "data-name": "Path 48386",
    d: "M116.813,31.226V30.95a1.645,1.645,0,0,0-1.619-1.669H102.437a1.644,1.644,0,0,0-1.62,1.669v.278Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29318",
    "data-name": "Group 29318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48538",
    "data-name": "Path 48538",
    d: "M100.817,32.309V39.6a1.709,1.709,0,0,0,1.619,1.788H105a1.965,1.965,0,0,1,.43-.753,2.018,2.018,0,0,1,1.885-.6v-2.6a2.008,2.008,0,0,1,4.015,0v2.5a1.944,1.944,0,0,1,.411-.043,2.012,2.012,0,0,1,1.476.645,1.962,1.962,0,0,1,.455.851h1.525a1.708,1.708,0,0,0,1.619-1.788v-7.29Zm5.221,3.848a.522.522,0,0,1-.5.541h-2.926a.522.522,0,0,1-.5-.541V34.551a.522.522,0,0,1,.5-.539h2.926a.522.522,0,0,1,.5.539Z",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_48539",
    "data-name": "Path 48539",
    d: "M112.213,41.379a.636.636,0,0,0-.952,0l-1.269,1.368V37.435a.676.676,0,1,0-1.348,0v5.412l-1.267-1.367a.641.641,0,0,0-.954,0,.768.768,0,0,0,0,1.028l2.372,2.559a.638.638,0,0,0,.953,0l2.465-2.66A.766.766,0,0,0,112.213,41.379Z",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWithdrawals16X16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_withdrawals16x16.e84f3260dcf115cd3e4c7ead5c4a6917.svg";